import CartSectionsPresenter from "../components/cart-sections/presenter/cart-sections.js";

const cartTitleSection = document.querySelector(`.section_cart-title`);
const cartSections = document.querySelectorAll(`.section_cart-promocode, .section_cart-order, .cart-products-wrapper, .button_share-cart`);

const cartSectionsComponent = new CartSectionsPresenter(cartTitleSection, cartSections);
cartSectionsComponent.init();
